import { render } from "./ToolBar.vue?vue&type=template&id=35f3bbc0&scoped=true"
import script from "./ToolBar.vue?vue&type=script&lang=js"
export * from "./ToolBar.vue?vue&type=script&lang=js"

import "./ToolBar.vue?vue&type=style&index=0&id=35f3bbc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f3bbc0"]])

export default __exports__